<template>
    <div id="print" v-if="!isEmpty(listCourseQuestion)" class="question_content" @touchmove="touchmove" :style="{'background-color': '#' + currentCourseQuestion.backgroundColor}">
        <input id="id_time_out" type="hidden" @click="resetShowGuide()">
        <input id="id_clear_time_out" type="hidden" @click="clearGuideTimeout()">
        <div class="transition" v-if="showTransition">
            <div class="back_nav2" v-on:click.stop="gameQuitClick"><img src="../../assets/back_nav.png"/></div>
            <div class="content">
                <div class="content2">
                    <img class="icon" src="@/Images/jili.png"/>
                    <div id="id_star_count" class="text">
                        <span class="success_tip">祝贺完成!</span>
                    </div>
                    <div class="content3">
                        <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                            <img src="../../Images/transition_comeback.png"/>
                        </div>
                        <div class="transition_next" v-on:click.stop="nextPageClick">
                            <span>{{pageType === 1 ? "认知游戏" : "亲子PK"}}</span>
                            <img src="../../assets/chevron-thin-right.png"/>
                        </div>
                    </div>
                </div>
            </div>
            <audio class="audio" :src="greatAudio" id="great_audio" @ended="playEnded('great_audio')" @error="playEnded('great_audio')"/>
        </div>
        <div v-if="showExitConfirm === 1" class="exit_transition">
            <div class="exit_content">
                <div class="exit_title">完成后，才可以获得星星哦</div>
                <div class="game_action">
                    <div class="game_quit" v-on:click.stop="gameQuitClick">
                        <img src="../../Images/game_quit.png"/>
                        <span>Quit</span>
                    </div>
                    <div class="game_continue" v-on:click.stop="gameContinueClick">
                        <img src="../../Images/game_continue.png"/>
                        <span>Continue</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isPlayingFail" class="playing_fail" @click="common_playAudio()">
            <img src="@/Images/icon_replay.png" />
        </div>

        <div class="star_transition" v-if="showStarTransition && starCount > 0">
            <div class="content">
                <div class="content2">
                    <div class="star_show">
                        <div class="icon1"><img id="star_img_1" style="display: none" :src="getStarImg(1)"/></div>
                        <div class="icon2"><img id="star_img_2" style="display: none" :src="getStarImg(2)"/></div>
                        <div class="icon3"><img id="star_img_3" style="display: none" :src="getStarImg(3)"/></div>
                    </div>
                    <div class="star_score">
                        <img class="icon" src="@/assets/star_score_s.png"/><span>+{{starCount}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="star_animation" style="display:none">
            <div class="star_score">
                <img class="icon" src="@/assets/star_score_s.png"/><span>+{{starCount}}</span>
            </div>
        </div>
        <div class="score_content" :style="{top:'20px', right:currentCourseQuestion.type === 2 ? '175px' : '10px'}"><img src="../../assets/star_score_s.png"/><span>{{totalStarCount}}</span></div>

        <audio class="audio" :src="starAudio" id="star_audio" @ended="playEnded('star_audio')" @error="playEnded('star_audio')" />
        <div class="back_nav" @click="backNav()"><img src="../../assets/back_nav.png"/></div>
        <div class="common_audio_play" @click="common_playAudio()">
            <div class="audio_playing_game img_play" :style="{display: isPlaying ? '' : 'none'}"></div>
            <img class="img_play" :style="{display: isPlaying ? 'none' : ''}" src="@/Images/audio_game3.png" height="40px" width="40px"/>
        </div>

        <!--拖拽题(左右结构)-->
        <!--类型（1单选题/2拖拽题(左右结构)/3多个归类题/4单个归类题/5拖拽题(上下结构)-->
        <div v-if="currentCourseQuestion.type === 2" class="drop_question_content">
            <input id="dp_old_top" type="hidden">
            <input id="dp_reset_option_place" type="hidden" @click="resetOptionPlace()">
            <input id="dp_question_answer" type="hidden">
            <div class="dp_question_sty"><img id="question" :src="geneNetworkPicture(currentCourseQuestion.picture)" alt=""/></div>
            <div class="dp_answer_sty">
                <div id="dp_answer" class="dp_answer_content_sty">
                    <img :class="itemOption.isRightAnswer === 0 ? 'answer_error' : ''" :id="'dp_drag_' + indexOption" v-drag="{bgWidth:currentCourseQuestion.pictureWidthForCalcCoordinate,
                 optionWidth:getOptionWidth(), optionRgith:35, optionTop:0, optionPadding:10, optionBorderWidth:2,
                 json:JSON.stringify(currentCourseQuestion.optionArray)}"
                         v-for="(itemOption,indexOption) in currentCourseQuestion.optionArray" :key="currentIndex + '_' + indexOption"
                         :style="{right:'10px', top:((indexOption + 1)*10 + indexOption*(getOptionWidth())) + 'px', width: getOptionWidth() + 'px', height: getOptionWidth() + 'px', 'pointer-events': 'auto'}" :src="geneNetworkPicture(itemOption.picture)" alt=""/>
                </div>
            </div>
            <audio :src="dpAudioUrl" id="dp_musicmp3"  style="display: none" @ended="dp_playEnded" @error="dp_playEnded" />
        </div>

        <!--拖拽题(上下结构)-->
        <div v-if="currentCourseQuestion.type === 5" class="drop_updown_question_content">
            <input id="input_dpu_question_answer" type="hidden">
            <input id="input_dpu_answer" type="hidden" value="" />
            <div class="dpu_question_sty"><img id="dpu_question" :src="geneNetworkPicture(currentCourseQuestion.picture)" alt=""/></div>
            <div id="dpu_answer" class="dpu_answer_sty">
                <div class="dpu_answer_content_sty">
                    <img :class="itemOption.isRightAnswer === 0 ? 'answer_error' : ''" :id="'dpu_drag_' + indexOption" v-drag3="{bgWidth: currentCourseQuestion.pictureWidthForCalcCoordinate,
                 optionWidth:clOptionWidth, json:JSON.stringify(currentCourseQuestion.optionArray), syncPlay:0}"
                         v-for="(itemOption,indexOption) in currentCourseQuestion.optionArray" :key="currentIndex + '_' + indexOption"
                         :style="{width:clOptionWidth + 'px', top: clOptionTop + 'px', left: (indexOption*(clOptionWidth + clOptionPadding) + 2*clOptionPadding) + 'px', 'pointer-events': 'auto'}" :src="geneNetworkPicture(itemOption.picture)" alt=""/>
                </div>
            </div>
            <audio :src="dpuAudioUrl" id="dpu_musicMp3" style="display: none" @ended="dpu_playEnded" @error="dpu_playEnded" controls=""/>
        </div>

        <!--归类题-->
        <div v-if="currentCourseQuestion.type === 3 || currentCourseQuestion.type === 4" class="classify_question_content">
            <input id="input_cl_question_answer" type="hidden">
            <input id="input_cl_answer" type="hidden" value="" />
            <div class="cl_question_sty"><img id="cl_question" :src="geneNetworkPicture(currentCourseQuestion.picture)" alt=""/></div>
            <div id="cl_answer" class="cl_answer_sty">
                <div class="cl_answer_content_sty">
                    <img :class="itemOption.isRightAnswer === 0 ? 'answer_error' : ''" :id="'cl_drag_' + indexOption" v-drag2="{bgWidth: currentCourseQuestion.pictureWidthForCalcCoordinate,
                 optionWidth:clOptionWidth, classifyJson:JSON.stringify(listClassifyResult), optionJson:JSON.stringify(currentCourseQuestion.optionArray)}"
                         v-for="(itemOption,indexOption) in currentCourseQuestion.optionArray" :key="currentIndex + '_' + indexOption"
                         :style="{width:clOptionWidth + 'px', top: clOptionTop + 'px', left: (indexOption*(clOptionWidth + clOptionPadding) + 2*clOptionPadding) + 'px', 'pointer-events': 'auto'}" :src="geneNetworkPicture(itemOption.picture)" alt=""/>
                </div>
            </div>
            <audio :src="clAudioUrl" id="cl_musicMp3" style="display: none" @ended="cl_playEnded" @error="cl_playEnded" controls=""/>
        </div>

        <!--选择题-->
        <div v-if="currentCourseQuestion.type === 1" class="choice_question_content">
            <audio class="audio" :src="ccErrorAudio" id="cc_error_audio" @ended="playEnded('cc_error_audio')" @error="playEnded('cc_error_audio')"/>
            <audio class="audio" :src="ccSuccessAudio" id="cc_success_audio" @ended="playEnded('cc_success_audio')" @error="playEnded('cc_success_audio')"/>

            <!-- 选项 -->
            <div class="c_option">
                <div class="c_option_img_item" v-for="(item,index) in currentCourseQuestion.optionArray" :key="index" @click="optionClick(item, index)">
                    <img class="lazy_img" v-lazy="$qiNiuDomainBase + item.picture" />
                    <div :id="'cc_error_' + index" class="c_error"><img src="@/assets/error.png"/></div>
                    <div :id="'cc_success_' + index" class="c_success"><img src="@/assets/success.png"/></div>
                </div>
            </div>

            <audio :src="ccAudioUrl" id="cc_musicMp3" style="display:none" @ended="c_playCEnded" @error="c_playCEnded"
                   controls=""/>
        </div>

        <!--找一找-->
        <div v-if="currentCourseQuestion.type === 6" class="lookfor_question_content">
            <div class="lf_question_sty" @touchstart="lookforTouchStart">
                <img id="lf_question" :src="geneNetworkPicture(currentCourseQuestion.picture)" alt=""/>
                <img :id="'lf_option' + indexOption" style="display:none"  v-for="(itemOption,indexOption) in currentCourseQuestion.optionArray" :key="currentIndex + '_' + indexOption" :src="geneNetworkPicture(itemOption.afterSelectPicture)" alt=""/>
            </div>

            <audio :src="lfAudioUrl" id="lf_musicMp3" style="display:none" @ended="lf_playCEnded" @error="lf_playCEnded" controls=""/>
        </div>
        <v-touch v-if="showClassGuide === 1" v-on:swipeleft="resetShowGuide" v-on:swiperight="resetShowGuide" v-on:swipeup="resetShowGuide" v-on:swipedown="resetShowGuide">
            <div id="id_class_guide" class='popContainer' @click="closeClassGuideClick"><img src="../../assets/up.png" alt=""/></div>
        </v-touch>
        <v-touch v-if="showDropGuide === 1" v-on:swipeleft="resetShowGuide" v-on:swiperight="resetShowGuide" v-on:swipeup="resetShowGuide" v-on:swipedown="resetShowGuide">
            <div id="id_drop_guide" class='popContainer2' @click="closeDropGuideClick"><img src="../../assets/finger.png" alt=""/></div>
        </v-touch>
        <div id="id_choice_guide" v-if="showChoiceGuide === 1" class='popContainer3' @click="closeChoiceGuideClick"><img src="../../assets/click.png" alt=""/></div>

        <div class="common_question_left" @click="backQuestionForLeftClick" style="left:0;display:none"><img src="../../assets/question_left.png"/></div>
        <div class="common_question_right" @click="nextQuestionForRightClick" :style="{right:currentCourseQuestion.type === 2 ? '165px' : '0'}"><img src="../../assets/question_right.png"/></div>
    </div>
</template>

<script>
    import $ from "jquery";
    import Vue from "vue";
    import Utils from '@/pages/Program/util2.js';

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
            $(".dp_question_sty img").css("height", "calc(100vh - 60px)");
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
            $(".dp_question_sty img").css("height", "calc(100vw - 60px)");
        }
    }

    export default {
        data() {
            return {
                // 拖拽题
                lessonId: 0,
                pageType:0,
                listCourseQuestion: [],
                currentCourseQuestion:{},
                currentIndex: 0,
                showTransition: false,
                ccErrorAudio: "https://img.xiaohuasheng.cn/error_tip.mp3",
                ccSuccessAudio: "https://img.xiaohuasheng.cn/success.mp3",
                ccAudioUrl: "",
                clAudioUrl: "",
                dpAudioUrl: "",
                dpuAudioUrl: "",
                lfAudioUrl: "",
                listClassifyResult: [],
                clOptionWidth: 90,
                clOptionTop: 10,
                clOptionPadding: 10,
                showClassGuide: 0,
                showDropGuide: 0,
                showChoiceGuide: 0,
                mTimeout: null,
                mChildTimeout: null,
                mDelayTime: 10000,
                greatAudio:"https://img.xiaohuasheng.cn/great.mp3",
                showExitConfirm: 0,
                canPointNextAnswer: true,
                lookforClickCount:0,
                starAudio:null,
                starCount:0,
                showStarTransition:false,
                totalStarCount:0,
                choiceQuestionError:0,
                finishQuestion:0,
                notNextQuestion: 0,
                isPlaying: false,
                isPlayingFail: false,
            }
        },
        methods:{
            getNextRight(type) {
                if (type === 2) {
                    return ((this.getOptionWidth() - 120)/2 + 35 + 10) + 'px';
                }

                if (type === 6) {
                    return "35px";
                }
                return  '10px';
            },
            getStarImg(count) {
                let that = this;
                return count <= that.starCount ? require('@/assets/star_score_s.png') : require('@/assets/star_score_n.png');
            },
            lookforTouchStart(e) {
                let that = this;
                let divPrint = document.getElementById('print');
                let imgQuestion = document.getElementById('lf_question');
                let pointX = e.touches[0].clientY;
                let pointY = divPrint.clientHeight - e.touches[0].clientX;
                let imgQuestionLeft = (divPrint.clientWidth - imgQuestion.width)/2;
                let scale = imgQuestion.width / that.currentCourseQuestion.pictureWidthForCalcCoordinate;

                for (let i = 0; i < that.currentCourseQuestion.optionArray.length; i++) {
                    let vQuestionOption = that.currentCourseQuestion.optionArray[i];

                    let currentPointX = imgQuestionLeft + parseInt(vQuestionOption.coordinateX) * scale;
                    let currentPointY = parseInt(vQuestionOption.coordinateY) * scale;
                    let rangeWidthOrRadius = parseInt(vQuestionOption.rangeWidthOrRadius) * scale;
                    let rangeHeight = parseInt(vQuestionOption.rangeHeight) * scale;

                    if (pointX > currentPointX &&  pointX < (currentPointX + rangeWidthOrRadius) &&
                        pointY > currentPointY && pointY < (currentPointY + rangeHeight)) {

                        let lfmusicMp3 = document.getElementById('lf_musicMp3');
                        lfmusicMp3.src = "https://img.xiaohuasheng.cn/" + vQuestionOption.audio;
                        lfmusicMp3.play();


                        if ($("#lf_option" + i).css("display") === "none") {
                            $("#lf_option" + i).show();
                            that.lookforClickCount += 1;
                        }
                    }
                }

                if (that.lookforClickCount === that.currentCourseQuestion.optionArray.length && that.finishQuestion !== 1) {
                    that.finishQuestion = 1;
                    that.notNextQuestion = 1;

                    setTimeout(() => {
                        that.clearGuideTimeout();
                        that.successGetStar();

                        // 过3.5秒跳转到下一步
                        setTimeout(function () {
                            that.nextQuestionClick();
                        }, 3500);
                    }, 500);
                }
            },
            dpuPlayEnded() {
            },
            successGetStarToNext() {
                let that = this;
                that.notNextQuestion = 1;

                if (that.finishQuestion !== 1) {
                    setTimeout(function () {
                        that.finishQuestion = 1;
                        that.successGetStar();

                        // 过3.5秒跳转到下一步
                        setTimeout(function () {
                            that.nextQuestionClick();
                        }, 3500);
                    }, 1500);
                }
            },
            successGetStar() {
                let that = this;
                that.successGetStarByCount(3);
            },
            successGetStarByCount(count) {
                let that = this;

                setTimeout(() => {
                    that.showStarView(count);
                }, 1500);
            },
            showStarView(count) {
                let that = this;

                that.starCount = count;
                that.starAudio = that.getProgramAudioUrl(that.starCount);
                that.showStarTransition = true;

                setTimeout(() => {
                    for(let i = 1; i <= 3; i++) {
                        $("#star_img_" + i).show(200 + i*350, function(){
                            if (i === 3) {
                                setTimeout(() => {
                                    that.showStarTransition = false;
                                    let starAnimation = $(".star_animation");
                                    starAnimation.show();
                                    starAnimation.animate({top:"20px", right:that.currentCourseQuestion.type === 2 ? '175px' : '10px'}, 500,function(){
                                        starAnimation.hide();
                                        starAnimation.css({top:"", right:""});
                                    });
                                    that.addStar(that.starCount);
                                }, 800);
                            }
                        });
                    }

                    let audioPlayer = document.getElementById('star_audio');

                    if (audioPlayer != null) {
                        audioPlayer.play();
                    }
                }, 200);
            },
            addStar(count) {
                let that = this;
                let url = "englishProgram/addStar/" + that.lessonId + "/" + count;
                this.$axios.get(url).then((response) => {
                    that.totalStarCount = parseInt(response.data);
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            gameQuitClick() {
                this.showExitConfirm = 0;
                this.$router.go(-1);
            },
            gameContinueClick() {
                this.showExitConfirm = 0;
            },
            showFinishTransition() {
                let that = this;
                that.showTransition = true;
                Utils.$emit('setStarCount','6');
            },
            closePage: function () {
                this.showTransition = false;
                this.$router.go(-1);
            },
            replayClick: function () {
                let that = this;
                that.showTransition = false;
                that.currentIndex = 0;
                that.listClassifyResult = [];
                that.canPointNextAnswer = true;
                that.lookforClickCount = 0;
                that.initData();
            },
            nextPageClick: function () {
                let that = this;

                if (that.pageType === 1) {
                    // 认知游戏
                    that.showTransition = false;
                    that.currentIndex = 0;
                    that.listClassifyResult = [];
                    that.canPointNextAnswer = true;
                    that.getGameQuestion2(that.lessonId, 2);
                } else {
                    // 亲子PK
                    this.$router.replace({name: "PParentChildPk", query: {lessonId: this.lessonId, fromPage: 1}});
                }
            },
            closeTransition() {
                this.closePage();
            },
            closeClassGuideClick(){
                this.showClassGuide = 0;
            },
            closeDropGuideClick(){
                this.showDropGuide = 0;
            },
            closeChoiceGuideClick(){
                this.showChoiceGuide = 0;
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            backNav:function(){
                this.showExitConfirm = 1;
            },
            showStatus:function (status) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:showStatusView:" + status;
                }

                if (vPlatform === 4) {
                    window.note.showStatusView(status);
                }
            },
            stopOtherAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:stopOtherAudio";
                }

                if (vPlatform === 4) {
                    window.note.stopOtherAudio();
                }
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            childClick:function() {
                this.$router.go(-1);
                setTimeout(() => {
                    this.$router.push({
                        name: "PExpansion",
                        query: {
                            lessonId: this.lessonId,
                        }
                    });
                }, 100);
            },
            learnWordClick:function() {
                this.$router.go(-1);
                setTimeout(() => {
                    this.$router.push({
                        name: "PCoreWord",
                        query: {
                            lessonId: this.lessonId,
                        }
                    });
                }, 100);
            },
            viewCourseClick:function() {
                this.replayClick();
            },
            resetOptionPlace:function() {
                let that = this;
                let optionIndex = 0;
                let tempIds = $("#dp_question_answer").val();
                let tempIdsArray = JSON.parse(tempIds);

                if (tempIdsArray === undefined || tempIdsArray == null || tempIdsArray.length === 0) {
                    return;
                }

                let vKeyValueArray = [];

                $(".dp_answer_content_sty img").each(function (index, item) {
                    if (tempIdsArray.indexOf(index) !== -1) {
                        return;
                    }

                    let vTop = ((optionIndex + 1)*10 + optionIndex*(that.getOptionWidth()));

                    $(item).css({"right": "8px", "left":"auto", "top": vTop + 'px',
                        "width": that.getOptionWidth() + "px", "height": that.getOptionWidth() + "px"});
                    optionIndex += 1;

                    var vKeyValue = {key:index, value:vTop};
                    vKeyValueArray.push(vKeyValue);
                });

                $("#dp_old_top").val(JSON.stringify(vKeyValueArray));
            },
            touchmove(e) {
                e.preventDefault();
            },
            getOptionWidth:function() {
                return 106;
            },
            showClickAnimate:function () {
                let that = this;

                if (that.showChoiceGuide !== 1) {
                    return;
                }

                $("#id_choice_guide").find("img").animate({height:"90px", width:"90px"},500,function(){
                    $("#id_choice_guide").find("img").animate({height:"70px", width:"70px"} , 500, that.showClickAnimate);
                });
            },
            showLeftRightAnimate:function () {
                let that = this;

                if (that.showDropGuide !== 1) {
                    return;
                }

                $("#id_drop_guide").find("img").animate({right:"150px"},1000,function(){
                    $("#id_drop_guide").find("img").animate({right:"35px"} , 0, that.showLeftRightAnimate);
                });
            },
            showUpDownAnimate:function () {
                let that = this;

                if (that.showClassGuide !== 1) {
                    return;
                }

                $("#id_class_guide").find("img").animate({bottom:"150px"},1000,function(){
                    $("#id_class_guide").find("img").animate({bottom:"30px"} , 0, that.showUpDownAnimate);
                });
            },
            showAnimate:function () {

            },
            backQuestionForLeftClick:function () {
                let that = this;

                if (that.notNextQuestion === 1 ) {
                    return;
                }

                that.currentIndex -= 1;
                that.clearGuideTimeout();

                // 返回按钮
                if (that.currentIndex <= 0) {
                    $(".common_question_left").hide();
                } else {
                    $(".common_question_left").show();
                }

                // 下一步按钮
                if (that.currentIndex >= that.listCourseQuestion.length - 1) {
                    $(".common_question_right").hide();
                } else {
                    $(".common_question_right").show();
                }

                that.notNextQuestion = 0;
                that.canPointNextAnswer = true;
                that.initData();
            },
            nextQuestionForRightClick:function () {
                let that = this;

                if (that.notNextQuestion === 1 ) {
                    return;
                }

                that.nextQuestionClick();
            },
            nextQuestionClick:function () {
                let that = this;

                that.currentIndex += 1;
                that.clearGuideTimeout();

                // 返回按钮
                if (that.currentIndex <= 0) {
                    $(".common_question_left").hide();
                } else {
                    $(".common_question_left").show();
                }

                // 下一步按钮
                if (that.currentIndex >= that.listCourseQuestion.length - 1) {
                    $(".common_question_right").hide();
                } else {
                    $(".common_question_right").show();
                }

                if (that.currentIndex >= that.listCourseQuestion.length) {
                    // 增加过度界面
                    that.showFinishTransition();
                    return;
                }

                that.notNextQuestion = 0;
                that.canPointNextAnswer = true;
                that.initData();
            },
            clearGuideTimeout:function () {
                let that = this;

                that.showChoiceGuide = 0;
                that.showDropGuide = 0;
                that.showClassGuide = 0;

                if (that.mTimeout != null) {
                    clearTimeout( that.mTimeout );
                }

                if (that.mChildTimeout != null) {
                    clearTimeout( that.mChildTimeout );
                }
            },
            initData:function () {
                let that = this;
                var vType = that.currentCourseQuestion.type;
                that.lookforClickCount = 0;

                // 2拖拽题(左右结构)
                if(vType === 2) {
                    $("#dp_question_answer").val("");
                    $("#dp_old_top").val("");
                    that.finishQuestion = 0;

                    $(".dp_answer_content_sty img").each(function (index, item) {
                        $(item).css({"right": "8px", "left":"auto", "top": ((index + 1)*10 + index*(that.getOptionWidth())) + 'px', "width": that.getOptionWidth() + "px", "height": that.getOptionWidth() + "px"});
                        $(item).unbind("click");
                    });
                }

                // 3多个归类题/4单个归类题
                if (vType === 3 || vType === 4) {
                    $("#input_cl_question_answer").val("");
                    $("#input_cl_answer").val("");
                    that.finishQuestion = 0;

                    $(".cl_answer_content_sty img").each(function (index, item) {
                        $(item).css({"left":(index*(that.clOptionWidth + that.clOptionPadding) + 2*that.clOptionPadding) + "px", top: that.clOptionTop + 'px', "width": that.clOptionWidth + "px"});
                        $(item).unbind("click");
                    });
                }

                // 5拖拽题(上下结构)
                if (vType === 5) {
                    $("#input_dpu_question_answer").val("");
                    $("#input_dpu_answer").val("");
                    that.finishQuestion = 0;

                    $(".dpu_answer_content_sty img").each(function (index, item) {
                        $(item).css({"left":(index*(that.clOptionWidth + that.clOptionPadding) + 2*that.clOptionPadding) + "px", top: that.clOptionTop + 'px', "width": that.clOptionWidth + "px"});
                        $(item).unbind("click");
                    });
                }

                // 找一找
                if (vType === 6) {
                    that.finishQuestion = 0;
                }

                that.currentCourseQuestion = that.listCourseQuestion[that.currentIndex];
                var vTypeNew = that.currentCourseQuestion.type;

                // 1单选题
                if (vTypeNew === 1) {
                    that.ccAudioUrl = "";

                    if (!that.isEmpty(that.currentCourseQuestion.audio)) {
                        that.ccAudioUrl = that.$qiNiuDomainBase + that.currentCourseQuestion.audio;

                        setTimeout(() => {
                            that.c_playCAudio();
                        }, 200);
                    }
                }

                // 2拖拽题(左右结构)
                if (vTypeNew === 2) {
                    that.dp_initAudioUrl();

                    setTimeout(() => {
                        //$("#dp_answer").css("background-color", "#ffffff");
                        //$(".dp_answer_sty").css("background-color", "transparent");
                    }, 20);

                    setTimeout(() => {
                        that.dp_playAudio();
                    }, 200);
                }

                // 3多个归类题/4单个归类题
                if (vTypeNew === 3 || vTypeNew === 4) {
                    that.cl_GetListClassifyResult(vTypeNew);

                    setTimeout(() => {
                        //$("#cl_answer").css("background-color", "#ffffff");
                    }, 20);
                }

                // 5拖拽题(上下结构)
                if (vTypeNew === 5) {
                    that.cl_GetListClassifyResult(vTypeNew);

                    setTimeout(() => {
                        //$("#dpu_answer").css("background-color", "#ffffff");
                    }, 20);
                }

                // 找一找
                if (vTypeNew === 6) {
                    that.lf_initAudioUrl();

                    setTimeout(() => {
                        that.lf_playAudio();
                    }, 20);
                }

                that.showGuide();
            },
            resetShowGuide: function () {
                let that = this;

                if (that.finishQuestion === 1) {
                    return;
                }

                that.clearGuideTimeout();
                that.showGuide();
            },
            showGuide: function () {
                let that = this;
                let vType = that.currentCourseQuestion.type;

                // 1单选题
                if (vType === 1) {
                    that.mTimeout = setTimeout(() => {
                        if (that.currentCourseQuestion.type !== 1) {
                            return;
                        }

                        that.showChoiceGuide = 1;

                        that.mChildTimeout = setTimeout(() => {
                            that.showClickAnimate();
                        }, 200);
                    }, that.mDelayTime);
                }

                // 2拖拽题
                if(vType === 2) {
                    that.mTimeout = setTimeout(() => {
                        if (that.currentCourseQuestion.type !== 2) {
                            return;
                        }

                        that.showDropGuide = 1;

                        that.mChildTimeout = setTimeout(() => {
                            that.showLeftRightAnimate();
                        }, 200);
                    }, that.mDelayTime);
                }

                // 3多个归类题/4单个归类题
                if (vType === 3 || vType === 4 || vType === 5) {
                    that.mTimeout = setTimeout(() => {
                        if (that.currentCourseQuestion.type !== 3 && that.currentCourseQuestion.type !== 4 && that.currentCourseQuestion.type !== 5) {
                            return;
                        }

                        that.showClassGuide = 1;

                        that.mChildTimeout = setTimeout(() => {
                            that.showUpDownAnimate();
                        }, 200);
                    }, that.mDelayTime);
                }
            },
            // 选择题
            c_getCQuestionText: function () {
                let that = this;
                let objQuestion = that.currentCourseQuestion;

                if (objQuestion == null) {
                    return "";
                }

                return objQuestion.text;
            },
            c_playErrorAudio() {
                const ccErrorAudio = document.getElementById('cc_error_audio');
                ccErrorAudio.play();
            },
            c_playSuccessAudio() {
                const ccSuccessAudioPlay = document.getElementById('cc_success_audio');
                ccSuccessAudioPlay.play();
            },
            optionClick:function(objQuestionOption, index) {
                let that = this;

                if (!that.canPointNextAnswer) {
                    return;
                }

                let isRightAnswer = that.getCount(objQuestionOption.isRightAnswer);
                $("#id_time_out").click();

                // 0不是正确答案/1是正确答案
                if (isRightAnswer === 0) {
                    that.c_playErrorAudio();
                    that.choiceQuestionError += 1;
                    $("#cc_error_" + index).show();

                    setTimeout(function () {
                        $("#cc_error_" + index).hide();
                    }, 500);

                    return;
                }

                that.canPointNextAnswer = false;
                that.c_playSuccessAudio();
                $("#cc_success_" + index).show();

                setTimeout(function () {
                    let vStarCount = 3;

                    if (that.choiceQuestionError === 1) {
                        vStarCount = 2;
                    } else if(that.choiceQuestionError > 1) {
                        vStarCount = 1;
                    }

                    // 显示星星
                    that.showStarView(vStarCount);

                    // 过2.5秒跳转到下一步
                    setTimeout(function () {
                        $("#cc_success_" + index).hide();
                        that.choiceQuestionError = 0;
                        that.nextQuestionClick();
                    }, 2500);

                }, 800);
            },
            common_playAudio() {
                let that = this;
                let type = that.currentCourseQuestion.type;
                that.isPlaying = true;

                if (type === 1) {
                    let ccmusicMp3 = document.getElementById('cc_musicMp3');
                    ccmusicMp3.src = that.ccAudioUrl;
                    that.c_playCAudio();
                }

                if (type === 2) {
                    let dpmusicMp3 = document.getElementById('dp_musicmp3');
                    dpmusicMp3.src = that.dpAudioUrl;
                    that.dp_playAudio();
                }

                if (type === 3 || type === 4) {
                    let clmusicMp3 = document.getElementById('cl_musicMp3');
                    clmusicMp3.src = that.clAudioUrl;
                    that.cl_playAudio();
                }

                if (type === 5) {
                    let dpumusicMp3 = document.getElementById('dpu_musicMp3');
                    dpumusicMp3.src = that.dpuAudioUrl;
                    that.dpu_playAudio();
                }

                if (type === 6) {
                    let lfmusicMp3 = document.getElementById('lf_musicMp3');
                    lfmusicMp3.src = that.lfAudioUrl;
                    that.lf_playAudio();
                }
            },
            // 设置播放音频
            dp_initAudioUrl() {
                let that = this;
                that.dpAudioUrl = "";

                if (!that.isEmpty(that.currentCourseQuestion.audio)) {
                    that.dpAudioUrl = that.$qiNiuDomainBase + that.currentCourseQuestion.audio;
                }
            },
            cl_initAudioUrl() {
                let that = this;
                that.clAudioUrl = "";

                if (!that.isEmpty(that.currentCourseQuestion.audio)) {
                    that.clAudioUrl = that.$qiNiuDomainBase + that.currentCourseQuestion.audio;
                }
            },
            cc_initAudioUrl() {
                let that = this;
                that.ccAudioUrl = "";

                if (!that.isEmpty(that.currentCourseQuestion.audio)) {
                    that.ccAudioUrl = that.$qiNiuDomainBase + that.currentCourseQuestion.audio;
                }
            },
            dpu_initAudioUrl() {
                let that = this;
                that.dpuAudioUrl = "";

                if (!that.isEmpty(that.currentCourseQuestion.audio)) {
                    that.dpuAudioUrl = that.$qiNiuDomainBase + that.currentCourseQuestion.audio;
                }
            },
            lf_initAudioUrl() {
                let that = this;
                that.lfAudioUrl = "";

                if (!that.isEmpty(that.currentCourseQuestion.audio)) {
                    that.lfAudioUrl = that.$qiNiuDomainBase + that.currentCourseQuestion.audio;
                }
            },
            // 播放音频
            playCAudio(audioUrl, idMusicMp3) {
                let that = this;

                if (that.isEmpty(audioUrl)) {
                    return;
                }

                let musicMp3 = document.getElementById(idMusicMp3);
                musicMp3.src = audioUrl;
                that.isPlayingFail = false;

                setTimeout(() => {
                    let playPromise = musicMp3.play();
                    that.isPlaying = true;

                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                        }).catch((e) => {
                            let vError = JSON.stringify(e);
                            that.isPlayingFail = true;
                            that.isPlaying = false;

                            if (!that.isEmpty(vError) && vError !== "{}") {
                                window.console.log("播放失败:playAudio:" + vError);
                            }
                        });
                    } else {
                        that.isPlaying = false;
                        window.console.log("播放失败:playAudio");
                    }
                }, 300);
            },
            c_playCAudio() {
                let that = this;
                that.playCAudio(that.ccAudioUrl, 'cc_musicMp3');
            },
            dp_playAudio() {
                let that = this;
                that.playCAudio(that.dpAudioUrl, 'dp_musicmp3');
            },
            cl_playAudio() {
                let that = this;
                that.playCAudio(that.clAudioUrl, 'cl_musicMp3');
            },
            dpu_playAudio() {
                let that = this;
                that.playCAudio(that.dpuAudioUrl, 'dpu_musicMp3');
            },
            lf_playAudio() {
                let that = this;
                that.playCAudio(that.lfAudioUrl, 'lf_musicMp3');
            },
            // 播放完成
            playEnded(idMusicmp3) {
                var musicMp3 = document.getElementById(idMusicmp3);
                let that = this;

                if (!(idMusicmp3 === 'great_audio' || idMusicmp3 === 'cc_error_audio' || idMusicmp3 === 'cc_success_audio')) {
                    that.isPlaying = false;
                }

                if (musicMp3 != null) {
                    musicMp3.pause();
                }
            },
            c_playCEnded() {
                let that = this;
                that.playEnded('cc_musicMp3');
            },
            dp_playEnded() {
                let that = this;
                that.playEnded('dp_musicmp3');
            },
            cl_playEnded() {
                let that = this;
                that.playEnded('cl_musicMp3');
            },
            dpu_playEnded() {
                let that = this;
                that.playEnded('dpu_musicMp3');
            },
            lf_playCEnded() {
                let that = this;
                that.playEnded('lf_musicMp3');
            },
            cl_GetListClassifyResult(type) {
                let that = this;
                var width = document.documentElement.clientWidth;
                var height = document.documentElement.clientHeight;

                let optionCount = that.currentCourseQuestion.optionArray.length;
                let optionHeight = width/4;
                let totalWidth = height - (optionCount - 1)*10 - 40;
                let singleHeight = optionHeight - 20;
                let avgWidth = totalWidth/optionCount;

                that.clOptionWidth = Math.min(singleHeight, avgWidth);
                that.clOptionTop = (optionHeight - that.clOptionWidth)/2 - 2;
                that.clOptionPadding = (height - optionCount*that.clOptionWidth)/(optionCount + 3);
                that.listClassifyResult = [];

                that.currentCourseQuestion.optionArray.forEach((item, index) => {
                    let hasResult = false;

                    if (item.isRightAnswer === 1) {
                        that.listClassifyResult.forEach((resultItem, resultIndex) => {
                            if (resultItem.x === item.coordinateX && resultItem.y === item.coordinateY) {
                                resultItem.totalCount += 1;
                                Vue.set(that.listClassifyResult, resultIndex, resultItem);
                                hasResult = true;
                            }
                        });

                        if (!hasResult) {
                            let objClassify = {};
                            objClassify.x = item.coordinateX;
                            objClassify.y = item.coordinateY;
                            objClassify.totalCount = 1;
                            objClassify.currentCount = 0;
                            that.listClassifyResult.push(objClassify);
                        }
                    }
                });

                setTimeout(() => {
                    if (type === 5) {
                        that.dpu_initAudioUrl();
                        that.dpu_playAudio();
                    } else {
                        that.cl_initAudioUrl();
                        that.cl_playAudio();
                    }
                }, 200);
            },
            getGameQuestion2(vLessonId, vType) {
                let that = this;
                let url = "/englishProgram/getGameQuestion2/" + vLessonId + "/" + vType;

                that.$axios.get(url).then((response) => {
                    that.listCourseQuestion = response.data;
                    that.currentCourseQuestion = that.listCourseQuestion[this.currentIndex];

                    that.lessonId = vLessonId;
                    that.pageType = vType;

                    var width = document.documentElement.clientWidth;
                    var height = document.documentElement.clientHeight;
                    that.hideStatusAndStopAudio();

                    let type = that.currentCourseQuestion.type;
                    that.isPlaying = true;

                    if (type === 1) {
                        that.cc_initAudioUrl();

                        setTimeout(() => {
                            that.c_playCAudio();
                        }, 200);
                    }

                    if (type === 2) {
                        that.dp_initAudioUrl();

                        setTimeout(() => {
                            that.dp_playAudio();
                        }, 200);
                    }

                    if (type === 3 || type === 4 || type === 5) {
                        let optionCount = that.currentCourseQuestion.optionArray.length;
                        let optionHeight = width/4;
                        let totalWidth = height - (optionCount - 1)*10 - 40;
                        let singleHeight = optionHeight - 20;
                        let avgWidth = totalWidth/optionCount;

                        that.clOptionWidth = Math.min(singleHeight, avgWidth);
                        that.clOptionTop = (optionHeight - that.clOptionWidth)/2 - 2;
                        that.clOptionPadding = (height - optionCount*that.clOptionWidth)/(optionCount + 3);
                        that.listClassifyResult = [];

                        that.currentCourseQuestion.optionArray.forEach((item, index) => {
                            let hasResult = false;

                            if (item.isRightAnswer === 1) {
                                that.listClassifyResult.forEach((resultItem, resultIndex) => {
                                    if (resultItem.x === item.coordinateX && resultItem.y === item.coordinateY) {
                                        resultItem.totalCount += 1;
                                        Vue.set(that.listClassifyResult, resultIndex, resultItem);
                                        hasResult = true;
                                    }
                                });

                                if (!hasResult) {
                                    let objClassify = {};
                                    objClassify.x = item.coordinateX;
                                    objClassify.y = item.coordinateY;
                                    objClassify.totalCount = 1;
                                    objClassify.currentCount = 0;
                                    that.listClassifyResult.push(objClassify);
                                }
                            }
                        });

                        if (type === 5) {
                            that.dpu_initAudioUrl();

                            setTimeout(() => {
                                that.dpu_playAudio();
                            }, 200);
                        } else {
                            that.cl_initAudioUrl();

                            setTimeout(() => {
                                that.cl_playAudio();
                            }, 200);
                        }
                    }

                    // 找一找
                    if (type === 6) {
                        that.lf_initAudioUrl();

                        setTimeout(() => {
                            that.lf_playAudio();
                        }, 200);
                    }

                    setTimeout(() => {
                        transformView();
                        that.showGuide();
                    }, 200);

                }).catch(function (error) {
                    window.console.log(error)
                });
            }
        },
        beforeRouteLeave(to, form, next) {
            this.showStatus(1);
            next();
        },
        created() {
            window.resetShowGuide = this.resetShowGuide;
            window.clearGuideTimeout = this.clearGuideTimeout;
            window.successGetStar = this.successGetStar;
            window.successGetStarToNext = this.successGetStarToNext;
            window.dpuPlayEnded = this.dpuPlayEnded;
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(that.$route.query.lessonId);
            let vType = parseInt(that.$route.query.type);
            let url = "/englishProgram/getGameQuestion2/" + vLessonId + "/" + vType;

            that.$axios.get(url).then((response) => {
                that.listCourseQuestion = response.data;
                that.currentCourseQuestion = that.listCourseQuestion[this.currentIndex];
                that.totalStarCount = parseInt(that.currentCourseQuestion.totalStarCount);
                that.lessonId = vLessonId;
                that.pageType = vType;

                var width = document.documentElement.clientWidth;
                var height = document.documentElement.clientHeight;
                that.hideStatusAndStopAudio();

                let type = that.currentCourseQuestion.type;

                if (type === 1) {
                    that.cc_initAudioUrl();

                    setTimeout(() => {
                        that.c_playCAudio();
                    }, 200);
                }

                if (type === 2) {
                    that.dp_initAudioUrl();

                    setTimeout(() => {
                        that.dp_playAudio();
                    }, 200);
                }

                if (type === 3 || type === 4 || type === 5) {
                    let optionCount = that.currentCourseQuestion.optionArray.length;
                    let optionHeight = width/4;
                    let totalWidth = height - (optionCount - 1)*10 - 40;
                    let singleHeight = optionHeight - 20;
                    let avgWidth = totalWidth/optionCount;

                    that.clOptionWidth = Math.min(singleHeight, avgWidth);
                    that.clOptionTop = (optionHeight - that.clOptionWidth)/2 - 2;
                    that.clOptionPadding = (height - optionCount*that.clOptionWidth)/(optionCount + 3);
                    that.listClassifyResult = [];

                    that.currentCourseQuestion.optionArray.forEach((item, index) => {
                        let hasResult = false;

                        if (item.isRightAnswer === 1) {
                            that.listClassifyResult.forEach((resultItem, resultIndex) => {
                                if (resultItem.x === item.coordinateX && resultItem.y === item.coordinateY) {
                                    resultItem.totalCount += 1;
                                    Vue.set(that.listClassifyResult, resultIndex, resultItem);
                                    hasResult = true;
                                }
                            });

                            if (!hasResult) {
                                let objClassify = {};
                                objClassify.x = item.coordinateX;
                                objClassify.y = item.coordinateY;
                                objClassify.totalCount = 1;
                                objClassify.currentCount = 0;
                                that.listClassifyResult.push(objClassify);
                            }
                        }
                    });

                    if (type === 5) {
                        that.dpu_initAudioUrl();

                        setTimeout(() => {
                            that.dpu_playAudio();
                        }, 200);
                    } else {
                        that.cl_initAudioUrl();

                        setTimeout(() => {
                            that.cl_playAudio();
                        }, 200);
                    }
                }

                // 找一找
                if (type === 6) {
                    that.lf_initAudioUrl();

                    setTimeout(() => {
                        that.lf_playAudio();
                    }, 200);
                }

                setTimeout(() => {
                    transformView();
                    that.showGuide();
                }, 200);

            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }
    .question_content .first_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(85, 85, 85, 0.96);
        z-index: 1003;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .question_content .first_content {
        position:relative;
    }

    .question_content .first_transition .first_content img {
        position: absolute;
        width: 79px;
        top: -50px;
        right: 20px;
    }

    .question_content .first_transition .first_content .content {
        background-color: #fef67e;
        width: 400px;
        padding: 20px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
        -moz-border-radius: 15px;
        border: 3px solid rgba(0, 0, 0, 1);
    }

    .question_content .first_transition .first_content .content .text {
        font-size: 16px;
        color: #101010;
    }

    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .back_nav img {
        width: 30px;
        height: 30px;
    }

    .common_audio_play .img_play {
        width: 40px;
        height: 40px;
    }

    .common_audio_play {
        position: absolute;
        display: flex;
        z-index: 999;
        left: 80px;
        top: 15px;
    }
    .common_audio_play img {
        width: 40px;
        height: 40px;
    }

    .question_content {
        position: relative;
    }

    .dp_question_sty {
        margin-top: 30px;
        position:absolute;
        width: calc(100% - 161px);
        text-align: center;
    }

    .dp_question_sty img {
        height: calc(100vmin - 60px);
    }

    .dp_answer_sty {
        position:absolute;
        width: 100%;
        height: 100vmin;
    }

    .dp_answer_content_sty {
        position:absolute;
        width: 126px;
        height: 100vh;
        right: 35px;
        background-color: white;
    }

    .dp_answer_sty img {
        position:absolute;
        display: inline-block;
        width: 100%;
    }

    .next_question {
        position:absolute;
        z-index: 999;
        width: 120px;
        height: 40px;
        bottom: 30px;
        background-color:#06A846;
        display: flex;
        align-items: center;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        animation: zoom 1s infinite;
    }

    .next_question .next_question_c {
        margin-left: 20px;
        display: inline-block;
    }

    .next_question .next_question_c span {
        display: inline-block;
        color: white;
        margin-right: 5px;
        font-weight: bold;
        vertical-align: middle;
    }

    .next_question .next_question_c img {
        display: inline-block;
        width: 30px;
        height: 30px;
        vertical-align: middle;
    }
    /*选择题*/
    .choice_question_content .c_option {
        margin-left: 60px;
        margin-right: 60px;
        margin-top: calc(50vmin - (100vmax - 200px)*7/36);
        display: flex;
        justify-content: space-between;
    }
    .choice_question_content .c_option .c_option_img_item {
        display: inline-flex;
        position: relative;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }
    .choice_question_content .c_option .c_option_img_item .lazy_img {
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        width: calc((100vmax - 200px)/3);
        height: calc((100vmax - 200px)*7/18);
    }
    .choice_question_content .c_option_img_item .c_error {
        position: absolute;
        bottom: 0;
        background-color: rgba(0,0,0,0.5);
        width: calc((100vmax - 200px)/3);
        height: calc((100vmax - 200px)*7/18);
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        display: none;
    }
    .choice_question_content .c_option_img_item .c_error img {
        position: absolute;
        width: 50%;
        height: auto;
        top: 50%;
        left: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .choice_question_content .c_option_img_item .c_success {
        position: absolute;
        z-index: 999;
        background-color: rgba(47,205,0,0.8);
        width: calc((100vmax - 200px)/3);
        height: calc((100vmax - 200px)*7/18);
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        display: none;
    }
    .choice_question_content .c_option_img_item .c_success img {
        position: absolute;
        width: 50%;
        height: auto;
        top: 50%;
        left: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .choice_question_content .c_question_content {
        position: absolute;
        display: flex;
        align-items: center;
        width: calc(60vmin + 20px);
        height: 20vmin;
        bottom: 50px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .choice_question_content .c_question_content .c_audio_play {
        position: relative;
        display: flex;
        z-index:600;
    }
    .choice_question_content .c_question_content .c_audio_play img {
        width: 40px;
        height: 40px;
    }
    .choice_question_content .c_question_content .c_content {
        position: relative;
        z-index:599;
        width: 60vmin;
        height: 20vmin;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: white;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        margin-left: -20px;
        padding-left: 30px;
        padding-right: 30px;
        font-size: 20px;
        color: #333333;
        font-family: Arial;
    }
    /*归类题*/
    .classify_question_content .cl_question_sty {
        position: absolute;
        width: 100%;
        text-align: center;
    }
    .classify_question_content .cl_question_sty img {
        height: auto;
        width: auto;
        max-width: calc(100vmax - 80px);
        max-height: 55vmin;
        margin-top: 20px;
    }
    .classify_question_content .cl_answer_sty {
        position: absolute;
        z-index: 990;
        display: flex;
        width: 100vmax;
        height: 25vmin;
        background-color: white;
        bottom: 20px;
    }
    .classify_question_content .cl_answer_content_sty img {
        position:absolute;
        z-index: 997;
        display: inline-block;
    }
    .classify_question_content .cl_next_question .next_question_c {
        margin-left: 20px;
        display: inline-block;
    }
    .classify_question_content .cl_next_question .next_question_c span {
        display: inline-block;
        color: white;
        margin-right: 5px;
        font-weight: bold;
        vertical-align: middle;
    }
    .classify_question_content .cl_next_question .next_question_c img {
        display: inline-block;
        width: 30px;
        height: 30px;
        vertical-align: middle;
    }
    /*拖拽题（上下结构）*/
    .drop_updown_question_content .dpu_question_sty {
        position: absolute;
        width: 100%;
        text-align: center;
    }
    .drop_updown_question_content .dpu_question_sty img {
        height: auto;
        width: auto;
        max-width: calc(100vmax - 80px);
        max-height: 55vmin;
        margin-top: 20px;
    }
    .drop_updown_question_content .dpu_answer_sty {
        position: absolute;
        z-index: 990;
        display: flex;
        width: 100vmax;
        height: 25vmin;
        background-color: white;
        bottom: 20px;
    }
    .drop_updown_question_content .dpu_answer_content_sty img {
        position:absolute;
        z-index: 997;
        display: inline-block;
    }
    .drop_updown_question_content .cl_next_question .next_question_c {
        margin-left: 20px;
        display: inline-block;
    }
    .drop_updown_question_content .cl_next_question .next_question_c span {
        display: inline-block;
        color: white;
        margin-right: 5px;
        font-weight: bold;
        vertical-align: middle;
    }
    .drop_updown_question_content .cl_next_question .next_question_c img {
        display: inline-block;
        width: 30px;
        height: 30px;
        vertical-align: middle;
    }

    .popContainer, .popContainer2, .popContainer3 {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .popContainer img {
        position: absolute;
        left: 50%;
        bottom: 30px;
        -webkit-transform: translateX(-50%);
        width: 70px;
    }
    .popContainer2 img {
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        right: 35px;
        width: 70px;
    }
    .popContainer3 img {
        position: absolute;
        left: 50%;
        -webkit-transform: translateX(-50%);
        top:calc((100vmin - 70px)/2.0);
        width: 70px;
        height: 70px;
    }

    .question_content .exit_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
        z-index: 1003;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .question_content .exit_content {
        position:relative;
    }
    .question_content .exit_content .exit_title {
        color: white;
        font-size: 18px;
        text-align: center;
        margin-bottom: 50px;
    }
    .question_content .exit_content .game_action .game_quit {
        display: inline-block;
        margin-right: 100px;
    }
    .question_content .exit_content .game_action .game_continue {
        display: inline-block;
    }
    .question_content .exit_content .game_action .game_quit img, .question_content .exit_content .game_action .game_continue img {
        display: block;
        width: 70px;
        margin-bottom: 10px;
    }
    .question_content .exit_content .game_action .game_quit span, .question_content .exit_content .game_action .game_continue span {
        display: block;
        text-align: center;
        font-size: 20px;
        color: white;
    }
    .lf_question_sty {
        position:absolute;
        width: 100%;
        height: 100vmin;
        text-align: center;
    }
    .lf_question_sty img {
        position:absolute;
        height: 100%;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }

    .question_content .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .question_content .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmin;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .question_content .transition .content2 {
        text-align: center;
    }

    .question_content .transition .content3 {
        text-align: center;
    }
    .question_content .transition .content .icon {
        margin-bottom: 10px;
        width: 35%;
    }
    .question_content .transition .content .text {
        width: 100%;
        margin-top: 5px;
    }
    .question_content .transition .content .text span {
        display: block;
        text-align: center;
    }
    .question_content .transition .content .text .success_tip {
        font-size: 24px;
    }
    .question_content .transition .content .star {
        height: 35px;
    }
    .question_content .transition .content .star .star_item {
        width: 35px;
        height: 35px;
        display: inline-block;
        position: relative;
    }
    .question_content .transition .content .star .star_item img {
        width: 35px;
        height: 35px;
        display: none;
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .question_content .transition .content .text span {
        width: 100%;
        color: white;
        font-size: 12px;
    }
    .transition_next {
        margin-top: 30px;
        display: inline-block;
        background-color: #07A745;
        width: 120px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    .transition_comeback {
        margin-top: 30px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .back_nav2 {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav2 img {
        width: 30px;
        height: 30px;
    }
</style>
